/* ROULETTE landing V2 (templates/page.lp-roulette-v2.liquid). */

/* 02 House rules: four slides (native scroll with snap) and four pockets
   as tabs. The active pocket follows the scroll, so swipes, trackpads and
   the keyboard stay in sync; a pocket click glides to its slide.
   The table: one casino wheel for the section, drawn here as SVG (37
   pockets in European order, so it matches the dial). A spin turns the
   wheel one way and the ball the other; the ball drops into the result
   under the pointer, then the verdict of the current game shows. By the
   3rd spin of a game the ball lands on another house number (7, 26, 19,
   0) and the section moves to that game. Reduced motion: no spin, the
   result shows at once. */
(function () {
  var root = document.querySelector('[data-rr]');
  if (!root) return;
  var track = root.querySelector('[data-rr-track]');
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-rr-slide]'));
  var pockets = Array.prototype.slice.call(root.querySelectorAll('[data-rr-pocket]'));
  if (!track || !slides.length) return;
  var index = 0;

  function goTo(i) {
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
  }

  /* ── The table ─────────────────────────────────────────────── */
  var table = root.querySelector('[data-rr-table]');
  var game = null;
  if (table && document.createElementNS) game = makeTable(table);

  function sync() {
    var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    i = Math.max(0, Math.min(slides.length - 1, i));
    if (i === index && pockets[i].classList.contains('is-active')) return;
    var changed = i !== index;
    index = i;
    pockets.forEach(function (p, n) {
      var on = n === i;
      p.classList.toggle('is-active', on);
      p.setAttribute('aria-selected', on ? 'true' : 'false');
      p.tabIndex = on ? 0 : -1;
    });
    if (changed && game) game.enter(i);
  }

  pockets.forEach(function (p, n) {
    p.addEventListener('click', function () { goTo(n); });
    p.addEventListener('keydown', function (event) {
      var to = event.key === 'ArrowRight' ? n + 1 : event.key === 'ArrowLeft' ? n - 1 : null;
      if (to === null) return;
      event.preventDefault();
      to = (to + pockets.length) % pockets.length;
      pockets[to].focus();
      goTo(to);
    });
  });
  track.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(index - 1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); goTo(index + 1); }
  });
  track.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();

  /* Desktop: the table sits under the rules column. Its top follows the
     tallest rules card, and the stage grows if the table reaches past the
     photos. Phones: the table is in the flow, nothing to place. */
  var stage = root.querySelector('.rr__stage');
  var wide = window.matchMedia('(min-width: 990px)');
  function place() {
    if (!table || table.hidden || !stage) return;
    stage.style.paddingBottom = '';
    if (!wide.matches) { root.style.removeProperty('--rr-table-top'); return; }
    var bottom = 0;
    slides.forEach(function (s) {
      var c = s.querySelector('.rr__card');
      if (c) bottom = Math.max(bottom, c.offsetTop + c.offsetHeight);
    });
    var top = bottom + 32;
    root.style.setProperty('--rr-table-top', top + 'px');
    var over = top + table.offsetHeight - track.offsetTop - track.offsetHeight;
    if (over > 0) stage.style.paddingBottom = over + 'px';
  }
  place();
  window.addEventListener('resize', place);
  window.addEventListener('load', place);

  function makeTable(el) {
    var NS = 'http://www.w3.org/2000/svg';
    var ORDER = [0, 32, 15, 19, 4, 21, 2, 25, 17, 34, 6, 27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33, 1, 20, 14, 31, 9, 22, 18, 29, 7, 28, 12, 35, 3, 26];
    var REDS = [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36];
    var STEP = 360 / ORDER.length;
    var FILL = { red: '#B8261F', black: '#151515', green: '#0F7A4A' };
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var houses = slides.map(function (s) { return Number(s.getAttribute('data-rr-start')); });
    var games = slides.map(function (s) { return s.getAttribute('data-rr-game'); });
    var names = slides.map(function (s) { return s.getAttribute('data-rr-name'); });

    var numEl = el.querySelector('[data-rr-num]');
    var colEl = el.querySelector('[data-rr-color]');
    var out = el.querySelector('[data-rr-verdict]');
    var button = el.querySelector('[data-rr-spin]');
    var buy = el.querySelector('[data-rr-buy]');

    var wheelTurn = 0;  /* degrees, clockwise */
    var ballTurn = 0;
    var spins = 0;      /* spins in the current game */
    var busy = false;
    var timer = null;

    function colourOf(n) { return n === 0 ? 'green' : REDS.indexOf(n) >= 0 ? 'red' : 'black'; }
    function verdict(g, n) {
      var c = colourOf(n);
      if (g === 'buy') return c === 'green' ? 'Zero. Split the round.' : c === 'red' ? 'Red. You’re buying.' : 'Black. They’re buying.';
      if (g === 'dinner') return n === 0 ? 'Zero. Watch wearer picks.' : n <= 12 ? 'Burgers tonight.' : n <= 24 ? 'Sushi tonight.' : 'Tacos tonight.';
      if (g === 'dare') return n === 0 ? 'Zero. Pass it on.' : n % 2 ? 'Odd. Truth.' : 'Even. Dare.';
      return 'Closest call to ' + n + ' wins.';
    }
    function node(name, attrs, parent) {
      var n = document.createElementNS(NS, name);
      for (var k in attrs) n.setAttribute(k, attrs[k]);
      if (parent) parent.appendChild(n);
      return n;
    }
    function polar(r, deg) {
      var a = (deg - 90) * Math.PI / 180;
      return [r * Math.cos(a), r * Math.sin(a)];
    }

    /* Draw: rim, pockets (pocket i centred at i * STEP, 0 on top), frets,
       numbers, cone, turret; the ball on its own layer. */
    var svg = node('svg', { viewBox: '-100 -100 200 200', class: 'rr__svg', focusable: 'false' });
    var defs = node('defs', {}, svg);
    var rim = node('radialGradient', { id: 'rr-rim', cx: '0', cy: '0', r: '100', gradientUnits: 'userSpaceOnUse' }, defs);
    node('stop', { offset: '0.82', 'stop-color': '#4A2C17' }, rim);
    node('stop', { offset: '0.92', 'stop-color': '#2B190D' }, rim);
    node('stop', { offset: '1', 'stop-color': '#160C06' }, rim);
    var gold = node('radialGradient', { id: 'rr-gold', cx: '-0.3', cy: '-0.3', r: '1.2' }, defs);
    node('stop', { offset: '0', 'stop-color': '#F6E2A8' }, gold);
    node('stop', { offset: '0.55', 'stop-color': '#D9B36C' }, gold);
    node('stop', { offset: '1', 'stop-color': '#8E6A2E' }, gold);
    var cone = node('radialGradient', { id: 'rr-cone', cx: '0', cy: '0', r: '52', gradientUnits: 'userSpaceOnUse' }, defs);
    node('stop', { offset: '0.3', 'stop-color': '#5A3A20' }, cone);
    node('stop', { offset: '1', 'stop-color': '#21140A' }, cone);

    node('circle', { r: 99, fill: 'url(#rr-rim)' }, svg);
    node('circle', { r: 86.5, fill: 'none', stroke: '#D9B36C', 'stroke-width': 1.4 }, svg);

    var wheel = node('g', { class: 'rr__rotor' }, svg);
    ORDER.forEach(function (n, i) {
      var a0 = i * STEP - STEP / 2;
      var a1 = a0 + STEP;
      var p0 = polar(85.5, a0), p1 = polar(85.5, a1), p2 = polar(56, a1), p3 = polar(56, a0);
      node('path', {
        d: 'M' + p0 + 'A85.5 85.5 0 0 1 ' + p1 + 'L' + p2 + 'A56 56 0 0 0 ' + p3 + 'Z',
        fill: FILL[colourOf(n)],
        stroke: '#D9B36C',
        'stroke-width': 0.5
      }, wheel);
      var t = polar(79, i * STEP);
      var label = node('text', {
        x: t[0], y: t[1],
        transform: 'rotate(' + (i * STEP) + ' ' + t[0] + ' ' + t[1] + ')',
        'text-anchor': 'middle',
        'dominant-baseline': 'central',
        class: 'rr__svg-num'
      }, wheel);
      label.textContent = String(n);
    });
    node('circle', { r: 72, fill: 'none', stroke: '#D9B36C', 'stroke-width': 0.7 }, wheel);
    node('circle', { r: 56, fill: 'url(#rr-cone)', stroke: '#D9B36C', 'stroke-width': 1 }, wheel);
    [0, 90, 180, 270].forEach(function (a) {
      var e = polar(34, a);
      node('line', { x1: 0, y1: 0, x2: e[0], y2: e[1], stroke: '#C9A25C', 'stroke-width': 3, 'stroke-linecap': 'round' }, wheel);
      node('circle', { cx: e[0], cy: e[1], r: 3.6, fill: 'url(#rr-gold)' }, wheel);
    });
    node('circle', { r: 13, fill: 'url(#rr-gold)', stroke: '#8E6A2E', 'stroke-width': 0.8 }, wheel);
    node('circle', { r: 5, fill: '#F6E2A8' }, wheel);

    var ballLayer = node('g', { class: 'rr__ball-orbit' }, svg);
    var ball = node('circle', { class: 'rr__ball', cx: 0, cy: -92, r: 3.6, fill: '#FBF7EE', stroke: 'rgba(0,0,0,0.35)', 'stroke-width': 0.6 }, ballLayer);
    node('path', { d: 'M-5 -101 L5 -101 L0 -92 Z', fill: 'url(#rr-gold)', stroke: '#8E6A2E', 'stroke-width': 0.5 }, svg);
    el.querySelector('[data-rr-wheel]').appendChild(svg);
    el.hidden = false;

    function setTurn(g, deg, ms, ease) {
      g.style.transition = ms ? 'transform ' + ms + 'ms ' + ease : 'none';
      g.style.transform = 'rotate(' + deg + 'deg)';
    }
    /* Angle the wheel must be turned to so number n sits under the pointer,
       ending at least `laps` clockwise turns beyond the current angle. */
    function wheelTarget(n, laps) {
      var want = -ORDER.indexOf(n) * STEP;
      var t = wheelTurn + laps * 360;
      var diff = ((want - t) % 360 + 360) % 360;
      return t + diff;
    }
    function show(n) {
      var c = colourOf(n);
      numEl.textContent = String(n);
      numEl.className = 'rr__result-num rr__chip--' + c;
      colEl.textContent = c.charAt(0).toUpperCase() + c.slice(1);
    }
    function idle(msg) {
      out.textContent = msg || 'Your call.';
      el.classList.remove('is-landed', 'is-house');
      button.textContent = 'Spin the wheel';
      button.disabled = false;
      buy.hidden = true;
    }
    function pick() {
      spins += 1;
      var current = houses[index];
      if (spins >= 3) {
        var others = houses.filter(function (h) { return h !== current; });
        return others[Math.floor(Math.random() * others.length)];
      }
      var n;
      do { n = Math.floor(Math.random() * 37); } while (houses.indexOf(n) >= 0 && n !== current);
      return n;
    }
    function settle(n) {
      busy = false;
      timer = null;
      show(n);
      var house = n !== houses[index] ? houses.indexOf(n) : -1;
      el.classList.add('is-landed');
      button.disabled = false;
      if (house >= 0) {
        el.classList.add('is-house');
        out.textContent = 'House number! Tonight’s game: ' + names[house] + '.';
        button.textContent = 'Spin again';
        buy.hidden = true;
        timer = window.setTimeout(function () {
          timer = null;
          moving = house;
          goTo(house);
          /* Never block a later pick if the glide is interrupted. */
          window.setTimeout(function () { if (moving === house) moving = -1; }, 2500);
        }, reduce ? 300 : 1400);
        return;
      }
      out.textContent = verdict(games[index], n);
      button.textContent = 'Spin again';
      buy.hidden = false;
    }
    function spin() {
      if (busy) return;
      if (timer) { window.clearTimeout(timer); timer = null; }
      var n = pick();
      el.classList.remove('is-landed', 'is-house');
      buy.hidden = true;
      if (reduce) {
        wheelTurn = wheelTarget(n, 0);
        setTurn(wheel, wheelTurn, 0);
        settle(n);
        return;
      }
      busy = true;
      button.disabled = true;
      button.textContent = 'Spinning…';
      out.textContent = 'No more bets…';
      wheelTurn = wheelTarget(n, 4);
      ballTurn = ballTurn - 360 * 6 - (((ballTurn % 360) + 360) % 360);
      setTurn(wheel, wheelTurn, 4600, 'cubic-bezier(0.15, 0.65, 0.12, 1)');
      setTurn(ballLayer, ballTurn, 4000, 'cubic-bezier(0.2, 0.7, 0.25, 1)');
      ball.style.transition = 'none';
      ball.style.transform = 'translateY(0)';
      window.setTimeout(function () {
        ball.style.transition = 'transform 700ms cubic-bezier(0.5, 0, 0.3, 1.4)';
        ball.style.transform = 'translateY(28px)';
      }, 3300);
      timer = window.setTimeout(function () { settle(n); }, 4700);
    }
    button.addEventListener('click', spin);

    /* A game was picked (by hand or by a house number): the wheel turns to
       its number and the count starts again. */
    var moving = -1;
    function enter(i) {
      /* A house number glides across the slides between: wait for its own. */
      if (moving >= 0 && i !== moving) return;
      spins = 0;
      if (timer) { window.clearTimeout(timer); timer = null; }
      busy = false;
      var n = houses[i];
      wheelTurn = wheelTarget(n, 0);
      setTurn(wheel, wheelTurn, reduce ? 0 : 900, 'cubic-bezier(0.22, 1, 0.36, 1)');
      ball.style.transition = 'none';
      ball.style.transform = 'translateY(28px)';
      ballTurn = ballTurn - (((ballTurn % 360) + 360) % 360);
      setTurn(ballLayer, ballTurn, 0);
      show(n);
      idle(moving === i ? 'Tonight’s game: ' + names[i] + '. Spin to play.' : 'Your call.');
      moving = -1;
    }

    /* Start on the first game, the ball resting in its pocket. */
    wheelTurn = wheelTarget(houses[0], 0);
    setTurn(wheel, wheelTurn, 0);
    ball.style.transform = 'translateY(28px)';
    show(houses[0]);
    return { enter: enter };
  }
})();

/* Every angle. Desktop: the section pins (CSS sticky) and the vertical
   scroll moves the strip sideways; each image's --f (1 in the middle, 0
   far off) brings it forward. Phones: the row drifts on its own to the
   end and back; a touch stops it, it resumes 3 s after
   the last touch, and only while on screen. Reduced motion: neither. */
(function () {
  var root = document.querySelector('[data-ra]');
  if (!root) return;
  var track = root.querySelector('[data-ra-track]');
  var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-ra-tile]'));
  if (!track || !tiles.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  var wide = window.matchMedia('(min-width: 990px)');
  var dist = 0;
  var ticking = false;

  /* Desktop film strip. The scroll sets a target; the strip glides toward
     it a little each frame (eased), so a mouse wheel's steps become one
     fluid movement. The section is 1.4× the strip's travel, so it also
     moves more slowly than the page. */
  var SLOW = 1.4;
  var x = 0;
  var target = 0;
  var centers = [];
  var gliding = false;
  var last = 0;
  function layout() {
    if (!wide.matches) {
      root.classList.remove('is-pinned');
      root.style.removeProperty('--ra-h');
      root.style.removeProperty('--ra-x');
      return;
    }
    root.classList.add('is-pinned');
    dist = Math.max(0, track.scrollWidth - window.innerWidth);
    root.style.setProperty('--ra-h', Math.round(window.innerHeight + dist * SLOW) + 'px');
    centers = tiles.map(function (t) { return t.offsetLeft + t.offsetWidth / 2; });
    aim();
    x = target;
    paint();
  }
  function aim() {
    var rect = root.getBoundingClientRect();
    var travel = Math.max(1, rect.height - window.innerHeight);
    var p = Math.min(1, Math.max(0, -rect.top / travel));
    target = p * dist;
  }
  function paint() {
    root.style.setProperty('--ra-x', x.toFixed(1));
    var mid = window.innerWidth / 2;
    var reach = window.innerWidth * 0.55;
    tiles.forEach(function (t, i) {
      var d = Math.abs(centers[i] - x - mid);
      t.style.setProperty('--f', Math.max(0, 1 - d / reach).toFixed(3));
    });
  }
  function glide(now) {
    var dt = last ? Math.min(64, now - last) : 16;
    last = now;
    /* About 90% of the way in a third of a second, whatever the frame rate. */
    x += (target - x) * (1 - Math.pow(0.001, dt / 1000));
    if (Math.abs(target - x) < 0.3) x = target;
    paint();
    if (x !== target) { window.requestAnimationFrame(glide); }
    else { gliding = false; last = 0; }
  }
  function move() {
    ticking = false;
    if (!wide.matches) return;
    aim();
    if (!gliding) { gliding = true; last = 0; window.requestAnimationFrame(glide); }
  }
  window.addEventListener('scroll', function () {
    if (ticking || !wide.matches) return;
    ticking = true;
    window.requestAnimationFrame(move);
  }, { passive: true });
  window.addEventListener('resize', layout);
  window.addEventListener('load', layout);
  layout();

  /* Phones: the drift, to the last image and back (each image shown once,
     no copies); it rests 1.5 s at each end. */
  var max = 0;
  var pos = 0;
  var dir = 1;
  var running = false;
  var visible = false;
  var holdUntil = 0;
  var last = 0;
  function measure() {
    max = Math.max(0, track.scrollWidth - track.clientWidth);
  }
  function step(now) {
    if (!running) return;
    var dt = last ? Math.min(64, now - last) : 16;
    last = now;
    if (visible && now > holdUntil && max > 0) {
      pos += dir * dt * 0.035;
      if (pos >= max || pos <= 0) {
        pos = Math.min(max, Math.max(0, pos));
        dir = -dir;
        holdUntil = now + 1500;
      }
      track.scrollLeft = pos;
    } else {
      pos = track.scrollLeft; /* picks up where a swipe left it */
    }
    window.requestAnimationFrame(step);
  }
  function startDrift() {
    if (wide.matches || running) return;
    measure();
    track.classList.add('is-auto');
    running = true;
    last = 0;
    window.requestAnimationFrame(step);
  }
  function stopDrift() {
    running = false;
    track.classList.remove('is-auto');
  }
  function hold() { holdUntil = performance.now() + 3000; }
  ['pointerdown', 'touchstart', 'wheel'].forEach(function (type) {
    track.addEventListener(type, hold, { passive: true });
  });
  track.addEventListener('pointerup', hold, { passive: true });
  track.addEventListener('touchend', hold, { passive: true });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { visible = entry.isIntersecting; });
    }).observe(track);
  } else {
    visible = true;
  }
  function mode() {
    if (wide.matches) stopDrift();
    else { startDrift(); measure(); }
  }
  if (wide.addEventListener) wide.addEventListener('change', function () { layout(); mode(); });
  window.addEventListener('resize', measure);
  mode();
})();

/* 01 Hero and 05 Owners: videos are muted, loop and have
   no controls; each plays only while on screen and pauses when it leaves.
   Reduced motion: it stays on its first frame (the hero's, which autoplays
   before this runs, is paused). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('[data-rlt-autoplay] video').forEach(function (video) {
    video.muted = true;
    video.controls = false;
    video.removeAttribute('controls');
    video.setAttribute('disablepictureinpicture', '');
    if (!video.hasAttribute('aria-label')) video.setAttribute('aria-label', 'The Roulette dial in motion');
    if (reduce && reduce.matches) { video.pause(); return; }
    function play() {
      var played = video.play();
      if (played && played.catch) played.catch(function () {});
    }
    if (!('IntersectionObserver' in window)) { play(); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) play();
        else video.pause();
      });
    }, { threshold: 0.35 }).observe(video);
  });
})();

/* 05 Reviews: a native scroll-snap slider. ‹ › move by one card; desktop
   and tablet get one dot per position, mobile a thumbnail strip and
   "1 / 7". Everything follows the scroll position, so swipes, trackpads
   and the keyboard stay in sync. The side arrows sit on the middle of the
   photos (--ro-media-h). */
(function () {
  var root = document.querySelector('[data-ro]');
  if (!root) return;
  var track = root.querySelector('[data-ro-track]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ro-card]'));
  if (!track || !cards.length) return;
  var prevs = root.querySelectorAll('[data-ro-prev]');
  var nexts = root.querySelectorAll('[data-ro-next]');
  var dotsBox = root.querySelector('[data-ro-dots]');
  var thumbs = root.querySelectorAll('[data-ro-thumb]');
  var current = root.querySelector('[data-ro-current]');
  var total = root.querySelector('[data-ro-total]');
  var dots = [];
  var index = 0;

  function step() {
    return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
  }
  function last() {
    /* The last position that still moves the track. */
    var max = track.scrollWidth - track.clientWidth;
    return Math.max(0, Math.ceil(max / step() - 0.05));
  }
  function goTo(i) {
    i = Math.max(0, Math.min(last(), i));
    track.scrollTo({ left: i * step(), behavior: 'smooth' });
  }
  function buildDots() {
    if (!dotsBox) return;
    var n = last() + 1;
    if (dots.length === n) return;
    dotsBox.innerHTML = '';
    dots = [];
    for (var i = 0; i < n; i++) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'ro__dot';
      d.tabIndex = -1;
      d.setAttribute('aria-label', 'Go to position ' + (i + 1));
      d.addEventListener('click', goTo.bind(null, i));
      dotsBox.appendChild(d);
      dots.push(d);
    }
    dotsBox.hidden = n < 2;
  }
  function sync() {
    index = Math.round(track.scrollLeft / step());
    var end = last();
    Array.prototype.forEach.call(prevs, function (b) { b.disabled = index <= 0; });
    Array.prototype.forEach.call(nexts, function (b) { b.disabled = index >= end; });
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === Math.min(index, end)); });
    Array.prototype.forEach.call(thumbs, function (t, i) {
      var on = i === index;
      t.classList.toggle('is-active', on);
      if (on && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
        t.parentNode.scrollTo({ left: t.offsetLeft - t.parentNode.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
      }
    });
    if (current) current.textContent = String(index + 1);
  }
  function layout() {
    var media = cards[0].querySelector('.ro__media');
    if (media) root.style.setProperty('--ro-media-h', media.offsetHeight + 'px');
    buildDots();
    sync();
  }

  Array.prototype.forEach.call(prevs, function (b) { b.addEventListener('click', function () { goTo(index - 1); }); });
  Array.prototype.forEach.call(nexts, function (b) { b.addEventListener('click', function () { goTo(index + 1); }); });
  Array.prototype.forEach.call(thumbs, function (t) {
    t.addEventListener('click', function () { goTo(Number(t.getAttribute('data-ro-thumb'))); });
  });
  track.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(index - 1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); goTo(index + 1); }
  });
  track.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', layout);
  if (total) total.textContent = String(cards.length);
  layout();
})();

/* 03 Made to be noticed: a drag slider, one photo at a time (the CSS
   centres the active one). The track moves with a single
   transform: it follows the pointer while dragging (rubber band at the
   ends), then glides to the next / previous photo when the drag passes 15%
   of a photo or is a quick flick; otherwise it glides back. ‹ ›, the
   dashes and the arrow keys glide the same way. Vertical swipes scroll the
   page (touch-action: pan-y). */
(function () {
  var root = document.querySelector('[data-rt]');
  if (!root) return;
  var viewport = root.querySelector('[data-rt-viewport]');
  var track = root.querySelector('[data-rt-track]');
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-rt-slide]'));
  var dots = root.querySelectorAll('[data-rt-dot]');
  var prev = root.querySelector('[data-rt-prev]');
  var next = root.querySelector('[data-rt-next]');
  if (!viewport || !track || !slides.length) return;
  var current = 0;

  function offset(i) { return slides[i].offsetLeft - slides[0].offsetLeft; }
  function place(x) { track.style.transform = 'translate3d(' + (-x) + 'px, 0, 0)'; }
  function goTo(index) {
    current = Math.max(0, Math.min(slides.length - 1, index));
    place(offset(current));
    slides.forEach(function (s, i) {
      s.classList.toggle('is-active', i === current);
    });
    Array.prototype.forEach.call(dots, function (d, i) {
      d.classList.toggle('is-active', i === current);
      if (i === current) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
    if (prev) prev.disabled = current === 0;
    if (next) next.disabled = current === slides.length - 1;
  }

  if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
  if (next) next.addEventListener('click', function () { goTo(current + 1); });
  Array.prototype.forEach.call(dots, function (d) {
    d.addEventListener('click', function () { goTo(Number(d.getAttribute('data-rt-dot'))); });
  });
  viewport.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(current - 1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); goTo(current + 1); }
  });

  /* Drag. Decided on the first few pixels: horizontal → slider, vertical
     → the page keeps scrolling. */
  var drag = null;
  viewport.addEventListener('pointerdown', function (event) {
    if (event.button !== 0) return;
    drag = { id: event.pointerId, x: event.clientX, y: event.clientY, base: offset(current), dx: 0, t: Date.now(), on: false };
  });
  viewport.addEventListener('pointermove', function (event) {
    if (!drag || event.pointerId !== drag.id) return;
    var dx = event.clientX - drag.x;
    var dy = event.clientY - drag.y;
    if (!drag.on) {
      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
      if (Math.abs(dy) > Math.abs(dx)) { drag = null; return; }
      drag.on = true;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture(event.pointerId);
    }
    /* Rubber band past the first and last photo. */
    var x = drag.base - dx;
    var max = offset(slides.length - 1);
    if (x < 0) x = x * 0.3;
    else if (x > max) x = max + (x - max) * 0.3;
    drag.dx = dx;
    place(x);
  });
  function end(event) {
    if (!drag || event.pointerId !== drag.id) return;
    var d = drag;
    drag = null;
    if (!d.on) return;
    viewport.classList.remove('is-dragging');
    var width = slides[current].offsetWidth;
    var fast = Math.abs(d.dx) / Math.max(1, Date.now() - d.t) > 0.5;
    if (d.dx < 0 && (fast || -d.dx > width * 0.15)) goTo(current + 1);
    else if (d.dx > 0 && (fast || d.dx > width * 0.15)) goTo(current - 1);
    else goTo(current);
  }
  viewport.addEventListener('pointerup', end);
  viewport.addEventListener('pointercancel', end);
  viewport.addEventListener('dragstart', function (event) { event.preventDefault(); });

  /* Keep the current photo in place when the layout changes size. */
  var resizeTimer = 0;
  window.addEventListener('resize', function () {
    viewport.classList.add('is-dragging');
    place(offset(current));
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () { viewport.classList.remove('is-dragging'); }, 100);
  });
  goTo(0);
})();

/* Showcase: a colour dot switches the watch and the strap-dependent specs
   here and selects that variant in the purchase (ktb:request-variant), so
   the mobile sticky bar follows; a finish chosen in the purchase moves the
   dot here too. CHOOSE THIS ONE then just glides to 06. */
(function () {
  var root = document.querySelector('[data-rs]');
  if (!root) return;
  var group = root.querySelector('[data-rs-swatches]');
  var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-rs-swatch]'));
  var shots = root.querySelectorAll('[data-rs-shot]');
  var label = root.querySelector('[data-rs-name]');
  if (!group || !swatches.length) return;
  group.hidden = false;

  function show(sw) {
    var key = sw.getAttribute('data-rs-swatch');
    swatches.forEach(function (s) {
      var on = s === sw;
      s.classList.toggle('is-active', on);
      s.setAttribute('aria-checked', on ? 'true' : 'false');
      s.tabIndex = on ? 0 : -1;
    });
    Array.prototype.forEach.call(shots, function (f) { f.classList.toggle('is-active', f.getAttribute('data-rs-shot') === key); });
    root.classList.toggle('is-leather', sw.getAttribute('data-rs-strap') === 'leather');
    if (label) label.textContent = sw.getAttribute('data-rs-label');
  }
  function pick(sw, focus) {
    show(sw);
    if (focus) sw.focus();
    document.dispatchEvent(new CustomEvent('ktb:request-variant', { detail: { variantId: Number(sw.getAttribute('data-variant-id')), source: 'rlt-showcase' } }));
  }
  swatches.forEach(function (sw, n) {
    sw.tabIndex = n === 0 ? 0 : -1;
    sw.addEventListener('click', function () { pick(sw); });
    sw.addEventListener('keydown', function (event) {
      var step = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 0;
      if (!step) return;
      event.preventDefault();
      pick(swatches[(n + step + swatches.length) % swatches.length], true);
    });
  });
  document.addEventListener('ktb:variant-change', function (event) {
    var id = String((event.detail || {}).variantId || '');
    var sw = swatches.filter(function (s) { return s.getAttribute('data-variant-id') === id; })[0];
    if (sw) show(sw);
  });
})();

/* 06 Purchase: the strap buttons and variant cards only ask the
   purchase controller (assets/kt-boltron-purchase.js) for a variant
   (ktb:request-variant); the UI then follows ktb:variant-change, so the
   controller stays the single source of truth (price, ADD TO CART, cart).
   Switching strap keeps the finish position (1st / 2nd). After a
   successful add from here, ADD TO CART shows a check for a moment. */
(function () {
  var root = document.querySelector('[data-rlt-buy]');
  if (!root) return;
  var finishes = Array.prototype.slice.call(root.querySelectorAll('[data-rlt-finish]'));
  var watches = root.querySelectorAll('[data-rlt-watch]');
  var tabs = root.querySelectorAll('[data-rlt-strap]');
  var names = root.querySelectorAll('[data-rlt-name]');
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-rlt-dot]'));

  function request(id) {
    document.dispatchEvent(new CustomEvent('ktb:request-variant', { detail: { variantId: Number(id), source: 'rlt-buy' } }));
  }
  function ofStrap(strap) {
    return finishes.filter(function (f) { return f.getAttribute('data-strap') === strap; });
  }
  function current() {
    var id = root.getAttribute('data-variant-id');
    for (var i = 0; i < finishes.length; i++) {
      if (finishes[i].getAttribute('data-variant-id') === id) return finishes[i];
    }
    return null;
  }

  function sync() {
    var active = current();
    if (!active) return;
    var strap = active.getAttribute('data-strap');
    var key = active.getAttribute('data-rlt-finish');
    root.setAttribute('data-strap', strap);
    finishes.forEach(function (f) {
      var on = f === active;
      f.classList.toggle('is-active', on);
      f.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    Array.prototype.forEach.call(watches, function (w) {
      w.classList.toggle('is-active', w.getAttribute('data-rlt-watch') === key);
    });
    Array.prototype.forEach.call(tabs, function (t) {
      var on = t.getAttribute('data-rlt-strap') === strap;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    Array.prototype.forEach.call(names, function (n) { n.textContent = active.getAttribute('data-name'); });
    dots.forEach(function (d) {
      var on = d.getAttribute('data-variant-id') === active.getAttribute('data-variant-id');
      d.classList.toggle('is-active', on);
      d.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    root.setAttribute('data-selection', active.getAttribute('data-name'));
  }

  finishes.concat(dots).forEach(function (f) {
    f.addEventListener('click', function () { request(f.getAttribute('data-variant-id')); });
  });
  Array.prototype.forEach.call(tabs, function (t) {
    t.addEventListener('click', function () {
      var active = current();
      var list = ofStrap(t.getAttribute('data-rlt-strap'));
      if (!list.length || (active && active.getAttribute('data-strap') === t.getAttribute('data-rlt-strap'))) return;
      var position = active ? Math.max(0, ofStrap(active.getAttribute('data-strap')).indexOf(active)) : 0;
      request(list[Math.min(position, list.length - 1)].getAttribute('data-variant-id'));
    });
  });
  document.addEventListener('ktb:variant-change', sync);
  sync();

  /* Add-on options (e.g. the necklace's Gold / Silver): colour swatches
     instead of the shared row's dropdown. The <select> stays (hidden) as
     the controller's source: a swatch sets its value and fires change. */
  var SWATCH = {
    gold: '#D4A017', 'yellow gold': '#D4A017', 'rose gold': '#D9A07A', rose: '#D9A07A',
    silver: '#D3D3D3', steel: '#C9CCCF', black: '#151413', white: '#F4F1EC',
    blue: '#2B4C8C', red: '#B5121B', green: '#0F6A43', brown: '#5A3424'
  };
  root.querySelectorAll('.ktb-addon [data-ktb-addon-variant]').forEach(function (select) {
    var wrap = select.closest('.ktb-addon__variant');
    var row = select.closest('.ktb-addon');
    /* "Gold · Change" under the title; the swatches open only on demand,
       so a visitor who never touches it simply gets the default colour. */
    var text = row && row.querySelector('.ktb-addon__text');
    if (!wrap || !text) return;
    var opt = document.createElement('span');
    opt.className = 'rlt-buy__opt';
    var current = document.createElement('span');
    var change = document.createElement('button');
    change.type = 'button';
    change.className = 'rlt-buy__opt-change';
    change.textContent = 'Change';
    change.setAttribute('aria-expanded', 'false');
    var group = document.createElement('div');
    group.className = 'rlt-buy__swatches';
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-label', (wrap.querySelector('label') || {}).textContent || 'Option');
    group.hidden = true;
    function open(on) {
      group.hidden = !on;
      current.hidden = on;
      change.hidden = on;
      change.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    change.addEventListener('click', function (event) {
      /* Inside the row's <label>: never toggle the add-on itself. */
      event.preventDefault();
      event.stopPropagation();
      open(true);
      var on = group.querySelector('[aria-checked="true"]') || group.querySelector('button');
      if (on) on.focus();
    });
    var buttons = Array.prototype.map.call(select.options, function (option) {
      var name = option.textContent.replace(/\s*\(unavailable\)\s*$/, '').trim();
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'rlt-buy__swatch';
      button.setAttribute('role', 'radio');
      button.setAttribute('aria-label', name);
      button.title = name;
      button.disabled = option.disabled;
      button.style.setProperty('--rlt-swatch', SWATCH[name.toLowerCase()] || '#8A8580');
      button.addEventListener('click', function (event) {
        /* Inside the row's <label>: never toggle the add-on itself. */
        event.preventDefault();
        event.stopPropagation();
        if (!select.disabled && select.value !== option.value) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          mark();
        }
        open(false);
        change.focus();
      });
      group.appendChild(button);
      return { button: button, option: option };
    });
    /* The row's thumbnail follows the chosen option's own image
       (data-image on the <option>, from the add-on snippet). */
    var thumb = row.querySelector('.ktb-addon__img');
    function mark() {
      buttons.forEach(function (b) {
        var on = b.option.value === select.value;
        b.button.setAttribute('aria-checked', on ? 'true' : 'false');
        if (on) current.textContent = b.button.getAttribute('aria-label') + ' ·';
        var image = b.option.getAttribute('data-image');
        if (on && thumb && image) {
          thumb.removeAttribute('srcset');
          thumb.src = image;
        }
      });
    }
    select.addEventListener('change', mark);
    mark();
    wrap.classList.add('has-swatches');
    opt.appendChild(current);
    opt.appendChild(change);
    opt.appendChild(group);
    text.appendChild(opt);
  });

  var atc = root.querySelector('[data-ktb-atc]');
  var label = atc && atc.querySelector('[data-ktb-atc-label]');
  var timer = 0;
  if (label) {
    document.addEventListener('cart:updated', function () {
      if (!root.classList.contains('is-busy')) return;
      /* The controller resets the label right after this event. */
      window.setTimeout(function () {
        var previous = label.textContent;
        window.clearTimeout(timer);
        atc.classList.add('is-added');
        label.textContent = 'Added';
        timer = window.setTimeout(function () {
          atc.classList.remove('is-added');
          if (label.textContent === 'Added') label.textContent = previous;
        }, 1600);
      }, 0);
    });
  }
})();

/* Mobile sticky buy bar: shown after 03 (Made to be noticed) has scrolled
   past and hidden while 06 (purchase) or the footer is on screen. Its button presses the
   purchase section's ADD TO CART (same variant, same gifts) and mirrors its
   disabled state; the label follows the purchase section's selection. */
(function () {
  var bar = document.querySelector('[data-rsb]');
  /* Shown once Every angle (or, without it, Made to be noticed) has scrolled past. */
  var table = document.getElementById('roulette-angles') || document.getElementById('roulette-table');
  var buy = document.getElementById('roulette-buy');
  var foot = document.querySelector('.rlt-foot');
  if (!bar || !table || !buy) return;
  var add = bar.querySelector('[data-rsb-add]');
  var name = bar.querySelector('[data-rsb-name]');
  var showcase = document.getElementById('roulette-showcase');
  /* The bar never adds to the cart: CHOOSE YOUR ROULETTE leads to the
     showcase until a finish is picked (a dot there or a card in 06), then
     shows that pick and leads on to the purchase. */
  var picked = false;
  var pastTable = false;
  var buyVisible = false;
  var footVisible = false;

  function update() {
    var show = pastTable && !buyVisible && !footVisible;
    bar.classList.toggle('is-shown', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (add) add.tabIndex = show ? 0 : -1;
  }
  /* Measured on scroll (two rects, cheap): 03 has fully scrolled past the
     top, and 06 is not on screen. */
  function measure() {
    var vh = window.innerHeight;
    var t = table.getBoundingClientRect();
    var bb = buy.getBoundingClientRect();
    pastTable = t.bottom < 0;
    buyVisible = bb.top < vh * 0.85 && bb.bottom > vh * 0.15;
    footVisible = !!foot && foot.getBoundingClientRect().top < vh;
    update();
  }
  window.addEventListener('scroll', measure, { passive: true });
  window.addEventListener('resize', measure);
  measure();

  function sync() {
    if (picked && name && buy.getAttribute('data-selection')) name.textContent = buy.getAttribute('data-selection');
  }
  document.addEventListener('ktb:request-variant', function (event) {
    var source = (event.detail || {}).source;
    if (source !== 'rlt-showcase' && source !== 'rlt-buy') return;
    picked = true;
    if (add) add.setAttribute('data-state', 'go');
  });
  document.addEventListener('ktb:variant-change', function () { window.setTimeout(sync, 0); });
  if (add) {
    add.addEventListener('click', function () {
      var to = picked ? buy : (showcase || buy);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      to.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }
})();

/* Announcement bar: counts down either data-rab-every hours from the
   visitor's first visit (kept in this browser, so a reload carries on;
   at zero a new round starts) or to one fixed deadline (data-rab-until,
   with its time zone), after which the bar is removed. Days show while
   more than a day is left. */
(function () {
  var bar = document.querySelector('[data-rab]');
  if (!bar) return;
  var every = parseFloat(bar.getAttribute('data-rab-every')) * 3600000;
  var KEY = 'rlt2-offer-start';
  function roundEnd() {
    var now = Date.now();
    var start = 0;
    try { start = parseInt(window.localStorage.getItem(KEY), 10) || 0; } catch (e) {}
    if (!start || start > now) {
      start = now;
      try { window.localStorage.setItem(KEY, String(start)); } catch (e) {}
    }
    return new Date(start + Math.floor((now - start) / every + 1) * every);
  }
  var until = every > 0 ? roundEnd() : new Date(bar.getAttribute('data-rab-until'));
  var d = bar.querySelector('[data-rab-d]');
  var dbox = bar.querySelector('[data-rab-dbox]');
  var dsep = bar.querySelector('[data-rab-dsep]');
  var h = bar.querySelector('[data-rab-h]');
  var m = bar.querySelector('[data-rab-m]');
  var s = bar.querySelector('[data-rab-s]');
  var timer = 0;

  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function tick() {
    var now = new Date();
    if (every > 0 && now >= until) until = roundEnd();
    if (isNaN(until) || now >= until) {
      window.clearInterval(timer);
      bar.remove();
      return;
    }
    var left = Math.floor((until - now) / 1000);
    var days = Math.floor(left / 86400);
    if (d) {
      if (dbox) dbox.hidden = days < 1;
      if (dsep) dsep.hidden = days < 1;
      d.textContent = pad(days);
    }
    h.textContent = pad(Math.floor(left / 3600) % 24);
    m.textContent = pad(Math.floor(left / 60) % 60);
    s.textContent = pad(left % 60);
  }
  tick();
  timer = window.setInterval(tick, 1000);
})();

/* In-page links (#roulette-buy, #roulette-motion…): a smooth scroll to the
   section instead of a jump. Reduced motion: native jump. */
(function () {
  var root = document.getElementById('roulette-page');
  if (!root) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  root.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#"]');
    if (!link || (reduce && reduce.matches)) return;
    var target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });
})();
